module.exports = __webpack_public_path__ + "static/media/relationship.beedb783.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/mentality/relationship.png
// module id = 181
// module chunks = 0